// extracted by mini-css-extract-plugin
export default {"block":"DownloadLimitsTariffModal__block--2QzO1","iconInfo":"DownloadLimitsTariffModal__iconInfo--2p5Ry"};